<template>
    <div class="bx_card_news detail type2">
        <div class="title_area">
            <h2 class="tit_cont">{{title}}</h2>
        </div>

        <div class="bx_cont" v-if="!needNoticeCoronaResponseResult">
            <div class="cont">
                <p>{{$t('CoronaResponseResult_notice')}}</p>
                <p>{{$t('CoronaResponseResult_descNotice')}}</p>
            </div>
        </div>
        <div class="bx_cont" v-else>

            <div class="cont">
                <p>{{isPassText}}</p>
                <template v-if="isPass">
                    <p>{{$t('CoronaResponseResult_descPass')}}</p>
                </template>
                <template v-else>
                    <p>{{$t('CoronaResponseResult_descNoPass1')}}</p>
                    <p>{{$t('CoronaResponseResult_descNoPass2')}}</p>
                    <p>{{$t('CoronaResponseResult_descNoPass3')}}</p>
                </template>

                <form action="#" onsubmit="return false">
                    <fieldset>
                        <div class="bx_btn">
                            <button type="button" class="btn_st6" style="margin-top: 0" v-if="isAllowEdit"
                                    @click="editCoronaResponse">{{$t('CoronaResponseResult_again')}}
                            </button>
                        </div>

                        <div class="bx_btn" v-if="isWebView">
                            <button type="button" class="btn_st6" @click="$router.back()">{{$t('common_confirm')}}</button>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import {schema} from '@/common/utils/webview.js';

export default {
    name: 'CoronaResponseResult',
    props: {
        title: {
            type: String,
            required: true,
        },
        isPass: {
            type: Boolean,
            required: true,
        },
        isWebView: {
            type: Boolean,
            required: true,
        },
        isAllowEdit: {
            type: Boolean,
            required: true,
        },
        needNoticeCoronaResponseResult: {
            type: Boolean,
            required: true,
        },
    },

    computed: {
        isPassText() {
            if (this.isPass) {
                return this.$t('CoronaResponseResult_pass');
            }
            return this.$t('CoronaResponseResult_noPass');
        },
    },

    methods: {
        editCoronaResponse() {
            this.$emit('editCoronaResponse');
        },
    },
};
</script>

<style scoped>
.bx_card_news.detail.type2 .bx_cont .bx_btn button {width:100%;height:50px;padding:14px 22px 19px;font-weight:600;}
.bx_card_news.detail.type2 .bx_cont .bx_btn {width:100%;margin-top:20px;}

</style>
